import { render } from "./DosificacionList.vue?vue&type=template&id=5fe1a064&scoped=true"
import script from "./DosificacionList.vue?vue&type=script&lang=js"
export * from "./DosificacionList.vue?vue&type=script&lang=js"

import "./DosificacionList.vue?vue&type=style&index=0&id=5fe1a064&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe1a064"]])

export default __exports__